module.exports = "/static/assets/c083eb7d85a76d2d205dcf97a46f76ac.svg";